import React, { ButtonHTMLAttributes, FC } from 'react'

import { ButtonDelete, ButtonPrimary, ButtonSecondary } from './CButton.style'

// Mui variants: 'text' | 'flat' | 'outlined' | 'contained' | 'raised' | 'fab' | 'extendedFab';
type CButtonVariant = 'fab' | 'outlined' | 'contained'

type CButtonColor = 'primary' | 'secondary' | 'danger'

type CButtonProps = {
  label?: string
  color?: CButtonColor
  variant?: CButtonVariant
} & ButtonHTMLAttributes<HTMLButtonElement>

const buttonMap: Record<CButtonColor, HTMLButtonElement> = {
  primary: ButtonPrimary,
  secondary: ButtonSecondary,
  danger: ButtonDelete,
}

const baseButton = (variant: CButtonColor): HTMLButtonElement => {
  return buttonMap[variant] || ButtonPrimary
}

export const CButton: FC<CButtonProps> = ({
  color = 'primary',
  variant = 'contained',
  label,
  children,
  className,
  ...props
}) => {
  const Component = baseButton(color)
  const classes = [className || '', variant].join(' ')
  return (
    // @ts-ignore
    <Component {...props} className={classes}>
      {children || label}
    </Component>
  )
}
